<template>
  <v-content
  >
    <v-unlogged-in-base-tool-bar />
    <v-img
      :src="topImage"
      gradient="to top right, rgba(0,0,0,.2), rgba(0,0,0,.7)"
      :height=700>
        <v-container
          fluid
        >
          <v-row>
            <v-col>
              <h1 class="white-text title--text" style="font-size: 4.5rem">Welcome To Prosense!!</h1>
            </v-col>
          </v-row>
          <v-row
            justify-md="end"
            justify-sm="end">
            <v-col
              md=6
              sm=10>
              <v-top-login/>
            </v-col>
          </v-row>
        </v-container>
    </v-img>
    <v-sheet
      class="main--text">
      <v-container
        fluid>
        <v-row
          dense>
          <v-col>
            <h1 class="title--text">
              さあ、プログラミングの勉強を始めましょう！
            </h1>
          </v-col>
        </v-row>
        <v-row
          no-gutters>
          <v-col>
            <h3 class="grey--text text--darken-2">
              <!-- Prosenseは、お子さまにピッタリの先生探しをサポートします。 -->
              Prosenseは、お子さまがご自宅で指導を受けられる通信教育サービスです。
            </h3>
          </v-col>
        </v-row>
      </v-container>
      <v-container
        >
        <v-to-contact-icon />
      </v-container>
    </v-sheet>
    <!-- <v-sheet
      color="blue lighten-5">
      <v-container
        class="main--text"
        fluid>
      <v-row
        justify=center>
        <v-col
          cols=auto>
          <h2 class="title--text">ご利用の流れ</h2>
        </v-col>
      </v-row>
      <v-row
        justify=center>
        <v-col
          cols=12
          md=10>
          <v-container
            fluid>
            <v-use-flow/>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    </v-sheet> -->
    <v-unlogged-in-footer/>
  </v-content>
</template>


<script>
import VTopLogin from "@/components/organisms/parent/VTopLogin.vue"
import VUnloggedInBaseToolBar from "@/components/organisms/parent/VUnloggedInBaseToolBar.vue"
import VUseFlow from "@/components/organisms/parent/VUseFlow"
import TopImage from "@/assets/img/parent_top_background.jpg"
import VUnloggedInFooter from '@/components/organisms/parent/VUnloggedInFooter.vue'
import VToContactIcon from '@/components/organisms/parent/VToContactIcon.vue'

export default {
  components: {
    VUnloggedInBaseToolBar,
    VTopLogin,
    VUseFlow,
    VUnloggedInFooter,
    VToContactIcon
  },
  data() {
    return {
      topImage: TopImage
    }
  },
  methods: {

  }
}
</script>

<style scoped>
.back-ground-style {
  background-image: url("../../../assets/img/parent_top_background.jpg");
  background-size: cover;
  height: 100%
}

.white-text {
  color: white;
}
</style>